<template>
  <DashboardStatCard
    title="Sales Count"
    subtitle="This month vs last month"
    icon="mdi-receipt-text-check"
    color="green"
    :loading="isLoading"
    to="/customer/list"
  >
    <span>{{ currentMonthToDate }}</span>
    <span class="compare-divider">/</span>
    <span class="compare-muted">{{ lastMonthToDate }}</span>

    <template v-if="false"></template>
  </DashboardStatCard>
</template>

<script>
import invoiceService from "@/modules/Invoice/service";
import DashboardStatCard from "@/modules/Home/components/DashboardStatCard";

export default {
  components: {
    DashboardStatCard,
  },

  data() {
    return {
      currentMonthToDate: 0,
      lastMonthToDate: 0,
      isLoading: true,
    };
  },

  mounted() {
    this.loadData();
  },

  methods: {
    async loadData() {
      const where = {
        limit: 1,
        start: this.$moment().startOf("month").toISOString(),
        end: this.$moment().endOf("day").toISOString(),
      };

      const thisMonth = await invoiceService.getAll(where);

      where.start = this.$moment()
        .subtract(1, "month")
        .startOf("month")
        .toISOString();

      where.end = this.$moment()
        .subtract(1, "month")
        .endOf("day")
        .toISOString();

      const lastMonth = await invoiceService.getAll(where);

      this.currentMonthToDate = thisMonth.count;
      this.lastMonthToDate = lastMonth.count;
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
.compare-divider {
  margin: 0 8px;
  color: #94a3b8;
}

.compare-muted {
  color: #64748b;
}
</style>